import React, { useState, useEffect } from "react";
import { Page, Card, TextField, Button, Banner, BlockStack, List, Link, Text } from "@shopify/polaris";
import axiosInstance from "../api/shopifyAPI";
import { useShopifyAppBridge } from "./AppBridgeProvider";

const SetupSteps = () => {
  return (
    <Card sectioned title="Setup Instructions">
      <BlockStack gap="400">
        <Text variant="bodyMd">
          Follow these steps to set up your Marketify integration:
        </Text>
        <List type="number">
          <List.Item>
            Navigate to{" "}
            <Link url="https://dashboard.profeeds.net/" external>
              Marketify Dashboard
            </Link>
            {" "}and create an account if you haven't already
          </List.Item>
          <List.Item>
            Click on "Add Shop" in the Marketify dashboard
          </List.Item>
          <List.Item>
            Complete the store setup process - you will receive an API token specifically for this store
          </List.Item>
          <List.Item>
            Copy the provided API token immediately
          </List.Item>
          <List.Item>
            Paste the token in the field below and click "Save Token"
          </List.Item>
        </List>
      </BlockStack>
    </Card>
  );
};

const AdminPage = () => {
  const [token, setToken] = useState("");
  const [message, setMessage] = useState("");
  const [savedToken, setSavedToken] = useState(null);

  const shop = new URLSearchParams(window.location.search).get("shop");
  // console.log(shop);

  const { sessionToken } = useShopifyAppBridge();

  useEffect(() => {
    const fetchToken = async () => {
      console.log("Sending request for shop:", shop);

      try {
        const response = await axiosInstance.get("/marketify/check-token", { params: { shop } });
        if (response.data.success) {
          setSavedToken(response.data.token);
          setToken(response.data.token);
        } else {
          setMessage(response.data.message || "Follow the instructions to get the token for your shop.");
        }
      } catch (error) {
        setMessage("Error checking token: " + error.message);
      }
    };

    if (shop) {
      fetchToken();
    } else {
      setMessage("Shop parameter is missing.");
    }
  }, []); // Arrayul gol asigură că funcția se execută doar o singură dată la montare
  


  const handleSave = async () => {
    try {
      const response = await axiosInstance.post("/marketify/save-token", 
        { token, shop },
        {
          headers: {
            Authorization: `Bearer ${sessionToken}`
          }
        }
      );
      setMessage(response.data.message);
      setSavedToken(token);
    } catch (error) {
      setMessage("Error saving token.");
    }
  };

  return (
    <Page title="Admin Settings">
      <BlockStack gap="500">
        <SetupSteps />
        <Card sectioned>
          <BlockStack gap="500">
            {message && (
              <Banner
                status={message.includes("Error") ? "critical" : "success"}
                title={message}
              />
            )}
            <TextField
              label="Enter Marketify token"
              value={token}
              onChange={(value) => setToken(value)}
              placeholder="Enter token"
            />
            <Button primary onClick={handleSave}>
              Save Token
            </Button>
          </BlockStack>
        </Card>
        {savedToken && <p>Saved Token: {savedToken}</p>}
      </BlockStack>
    </Page>
  );
};

export default AdminPage;
